import { IArticleCommentsData, IArticleCommentsAction } from 'models/magazine/article/articlecomments';
import { IArticleComment } from 'models/magazine/article/articlecomment';
import { IStore } from 'redux/IStore';
import { IPage } from 'models/common';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
const { notifSend } = notifActions;

/** Action Types */
export const REQUEST_START: string = 'articlecomments/REQUEST_START';
export const REQUEST_FAILURE: string = 'articlecomments/REQUEST_FAILURE';
export const GET_ARTICLE_COMMENTS_SUCCESS: string = 'articlecomments/GET_ARTICLE_COMMENTS_SUCCESS';
export const RESET_DATA: string = 'articlecomments/RESET_DATA';
export const SET_COMMENTS_PAGE: string = 'articlecomments/SET_COMMENTS_PAGE';
export const SET_IS_ADMIN_PAGE: string = 'articlecomments/SET_IS_ADMIN_PAGE';
// TODO: NOT YET TESTED
export const LIKE_ARTICLE_COMMENT_SUCCESS: string = 'articlecomments/LIKE_ARTICLE_COMMENT_SUCCESS';

/** Initial State */
const initialState: IArticleCommentsData = {
	comments: [],
	commentsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	isAdminPage: false,
};

/** Reducer */
export function articleCommentsReducer(state = initialState, action: IArticleCommentsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case GET_ARTICLE_COMMENTS_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				comments: action.payload.comments,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				comments: [],
				commentsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
			});

		case SET_COMMENTS_PAGE:
			return Object.assign({}, state, {
				commentsPage: action.payload.commentsPage,
			});

		case SET_IS_ADMIN_PAGE:
			return Object.assign({}, state, {
				isAdminPage: action.payload.isAdminPage,
			});

		// TODO: NOT YET TESTED
		case LIKE_ARTICLE_COMMENT_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
			});

		default:
			return state;
	}
}

/** Async Action Creator */
export function deleteArticleComment(commentId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/Comment/' + commentId,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(deleteArticleCommentFromList(commentId));
					dispatch(
						notifSend({
							message: i18n.t('Notification_Success_Article_Comment_Deleted'),
							kind: 'success',
							dismissAfter: 3000,
						}),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

export function getArticleComments(isFirstLoad: boolean, isAdminPage: boolean, articleId: string) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
			dispatch(setIsAdminPage(isAdminPage));
		}

		dispatch(requestStart());

		const currentPage: number = getState()?.articleComments ? getState().articleComments.commentsPage?.currentPage : 0;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = 100000; // Don't ask

		return fetch(
			getState().fetchDefault.baseAPI +
				'api/Article/' +
				articleId +
				'/Comments' +
				`?currentPage=${newPage}&itemsPerPage=${itemsPerPage}`,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IPage) => {
						// console.log("res", res)
						const commentsState: IArticleCommentsData = getState().articleComments;
						const newComments: IArticleComment[] = res.items;

						if (commentsState) {
							const comments: IArticleComment[] = commentsState.comments;
							Array.prototype.push.apply(comments, newComments);
							dispatch(getArticleCommentsSuccess(comments));
						} else {
							dispatch(getArticleCommentsSuccess(newComments));
						}

						dispatch(setCommentsPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getAllArticleComments(isFirstLoad: boolean, isAdminPage: boolean) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
			dispatch(setIsAdminPage(isAdminPage));
		}

		dispatch(requestStart());

		const currentPage: number = getState().articleComments.commentsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().articleComments.commentsPage.itemsPerPage;

		const data: any = {
			CurrentPage: newPage,
			ItemsPerPage: itemsPerPage,
		};

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/Comment',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(data),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IPage) => {
						const commentsState: IArticleCommentsData = getState().articleComments;
						const comments: IArticleComment[] = commentsState.comments;
						const newComments: IArticleComment[] = res.items;
						Array.prototype.push.apply(comments, newComments);
						dispatch(getArticleCommentsSuccess(comments));
						dispatch(setCommentsPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function reviewArticleComment(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/Comment/' + id + '/Review',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(updateReviewedArticleComment(id));
					dispatch(
						notifSend({
							message: i18n.t('Notification_Success_Article_Comment_Reviewed'),
							kind: 'success',
							dismissAfter: 3000,
						}),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function updateReviewedArticleComment(commentId: string) {
	return (dispatch, getState: () => IStore) => {
		const comments: IArticleComment[] = getState().articleComments.comments;
		const index = comments.indexOf(comments.find((x: IArticleComment) => x.id === commentId));
		const comment = comments[index];
		comment.reviewed = true;
		comments[index] = comment;
		dispatch(getArticleCommentsSuccess(comments));
	};
}

/** Action Creator */
export function deleteArticleCommentFromList(commentId: string) {
	return (dispatch, getState: () => IStore) => {
		const comments: IArticleComment[] = getState().articleComments.comments;
		const index = comments.indexOf(comments.find((x: IArticleComment) => x.id === commentId));
		comments.splice(index, 1);
		dispatch(getArticleCommentsSuccess(comments));
	};
}

/** Action Creator */
export function updateArticleCommentInList(comment: IArticleComment) {
	return (dispatch, getState: () => IStore) => {
		const comments: IArticleComment[] = getState().articleComments.comments;
		const index = comments.indexOf(comments.find((x: IArticleComment) => x.id === comment.id));
		comments[index] = comment;
		dispatch(getArticleCommentsSuccess(comments));
	};
}

/** Action Creator */
export function setArticleCommentsFromArticleCard(comments: IArticleComment[], isAdminPage: boolean) {
	return (dispatch) => {
		dispatch(setIsAdminPage(isAdminPage));
		dispatch(getArticleCommentsSuccess(comments));
	};
}

/** Action Creator */
export function requestStart(): IArticleCommentsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function requestFailure(message: any): IArticleCommentsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function getArticleCommentsSuccess(comments: IArticleComment[]): IArticleCommentsAction {
	return {
		type: GET_ARTICLE_COMMENTS_SUCCESS,
		payload: {
			comments,
		},
	};
}

/** Action Creator */
export function resetData(): IArticleCommentsAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function setCommentsPage(commentsPage: IPage): IArticleCommentsAction {
	return {
		type: SET_COMMENTS_PAGE,
		payload: {
			commentsPage,
		},
	};
}

/** Action Creator */
export function setIsAdminPage(isAdminPage: boolean): IArticleCommentsAction {
	return {
		type: SET_IS_ADMIN_PAGE,
		payload: {
			isAdminPage,
		},
	};
}

export function likeArticleCommentSuccess(): IArticleCommentsAction {
	return {
		type: LIKE_ARTICLE_COMMENT_SUCCESS,
	};
}
